var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "portal",
        { attrs: { to: "modal" } },
        [
          _vm.showModal
            ? _c("modal", {
                attrs: { large: true },
                on: {
                  hide: function ($event) {
                    _vm.showModal = false
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          !_vm.complete
                            ? [
                                _c("h2", { staticClass: "mb-3" }, [
                                  _vm._v(_vm._s(_vm.formConfig.title)),
                                ]),
                                _vm._v(" "),
                                _vm.formConfig.body
                                  ? _c("div", {
                                      staticClass: "text-gray-600",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.formConfig.body),
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasError("key")
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mt-6 text-xs text-red-600",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.getErrorFor("key")) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "grid sm:grid-cols-2 gap-6 mt-6",
                                  },
                                  _vm._l(
                                    _vm.formConfig.form_fields,
                                    function (field, index) {
                                      return _c("form-input", {
                                        key: field.name,
                                        class: {
                                          "sm:col-span-2":
                                            _vm.hasOddNumberOfFormFields &&
                                            index + 1 ===
                                              _vm.formConfig.form_fields.length,
                                        },
                                        attrs: {
                                          type: field.type,
                                          label: field.label,
                                          name: field.name,
                                          id: field.name,
                                          error: _vm.getErrorFor(field.name),
                                        },
                                        model: {
                                          value: _vm.form[field.name],
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, field.name, $$v)
                                          },
                                          expression: "form[field.name]",
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex items-center mt-6" },
                                  [
                                    _c("form-toggle", {
                                      model: {
                                        value: _vm.form.privacy_policy,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "privacy_policy",
                                            $$v
                                          )
                                        },
                                        expression: "form.privacy_policy",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "ml-2" }, [
                                      _vm._v(
                                        "\n                        I have read and accept the\n                        "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-primary-600 hover:underline",
                                          attrs: {
                                            href: "/privacy_policy",
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v("privacy policy")]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.hasError("privacy_policy")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ml-12 mt-1 text-xs text-red-600",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.getErrorFor("privacy_policy")
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-5 sm:mt-12 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "flex w-full rounded-md shadow-sm sm:col-start-2",
                                      },
                                      [
                                        _c(
                                          "form-button",
                                          {
                                            staticClass: "w-full",
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.submitLeadForm.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.formConfig
                                                    .submit_button_text
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1",
                                      },
                                      [
                                        _c(
                                          "form-button",
                                          {
                                            staticClass: "w-full",
                                            attrs: { colour: "white" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.rejectLeadForm(
                                                  props.hide
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            No Thanks\n                        "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "mt-8 text-sm text-gray-500",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.formConfig.terms),
                                  },
                                }),
                              ]
                            : [
                                _c("h2", { staticClass: "mb-3" }, [
                                  _vm._v(_vm._s(_vm.complete_title)),
                                ]),
                                _vm._v(" "),
                                _vm.complete_body
                                  ? _c("div", {
                                      staticClass: "text-gray-600 space-y-4",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.complete_body),
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-5 sm:mt-12 sm:grid sm:gap-3 sm:grid-flow-row-dense",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1",
                                      },
                                      [
                                        _c(
                                          "form-button",
                                          {
                                            staticClass: "w-full",
                                            attrs: { colour: "white" },
                                            nativeOn: {
                                              click: function ($event) {
                                                return props.hide()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            Close\n                        "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  68703526
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }